var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgListBlack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.106,
    height: 18.285,
    viewBox: "0 0 24.106 18.285",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "list_grey",
    transform: "translate(0.001 -73.861)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x31_0_21_",
    transform: "translate(0 73.862)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1923",
    "data-name": "Group 1923"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1604",
    "data-name": "Path 1604",
    d: "M2.494,73.862a2.494,2.494,0,1,0,2.493,2.493,2.494,2.494,0,0,0-2.493-2.493Zm0,6.649A2.494,2.494,0,1,0,4.987,83,2.494,2.494,0,0,0,2.494,80.511Zm0,6.649a2.493,2.493,0,1,0,2.493,2.493A2.493,2.493,0,0,0,2.494,87.16Zm6.649-9.143h13.3a1.662,1.662,0,0,0,0-3.325H9.143a1.662,1.662,0,0,0,0,3.325Zm13.3,3.325H9.143a1.662,1.662,0,0,0,0,3.325h13.3a1.662,1.662,0,0,0,0-3.325Zm0,6.649H9.143a1.662,1.662,0,0,0,0,3.325h13.3a1.662,1.662,0,0,0,0-3.325Z",
    transform: "translate(0 -73.862)",
    fill: "#000000"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListBlack);
export default __webpack_public_path__ + "static/media/list_black.84378da871529e0cb03ebbb7977c9f20.svg";
export { ForwardRef as ReactComponent };